import { FC, useEffect, useState } from 'react';
import { CommonModal } from '../CommonModal';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';
import changeDeliveryDateModalClass from '../../assets/scss/ChangeDeliveryDateModal/ChangeDeliveryDateModal.module.scss';
import { BillingPolicyIntervalType } from '../../types/api/SubscriptionApiType';
import { postMessageGtag } from '../../utils/trackClick';
import { Billing } from '../../hooks/use-update-subscription-line-plan';

type IntervalType = {
  intervalCount: number;
  unit: string;
};

const INTERVAL_UNIT_MAP: Record<string, string> = {
  DAY: '日ごと',
  WEEK: '週ごと',
  MONTH: 'ヶ月ごと',
  YEAR: '年ごと',
};

export const ChangeDeliveryIntervalModal: FC<{
  active: boolean;
  closeFunc: () => void;
  interval: BillingPolicyIntervalType | undefined;
  intervalCount: number | undefined;
  modal: Billing[] | null;
  loading: boolean;
  clickUpdateBtnFunc: (intervalCount: number) => void;
}> = ({ active, closeFunc, interval, intervalCount, modal, loading, clickUpdateBtnFunc }) => {
  const [selectedValue, setSelectedValue] = useState(0);

  useEffect(() => {
    // 初期化
    if (active && intervalCount) {
      setSelectedValue(intervalCount);
    }
  }, [active, intervalCount]);

  if (!active) return null;

  const isUpdateDate = selectedValue !== 0 && intervalCount !== selectedValue;

  const isIntervals = modal && intervalCount && interval;
  const intervals = isIntervals ? getIntervals(intervalCount, interval, modal) : [];

  // GAタグ
  const eventCategory = 'detailCalender';
  const eventName_selectPrefix = 'click_period_';
  const eventName_changeIntervalBtn = 'click_period';
  const eventName_closeBtn = 'click_modal_close_period_cancel';
  const eventName_closeOutsideBtn = 'click_modal_close_period';

  const content = (
    <>
      <div className={changeDeliveryDateModalClass.container}>
        <div className={changeDeliveryDateModalClass.title}>周期の変更</div>
        <div className={changeDeliveryDateModalClass.intervalsContainer}>
          {intervals.map((option) => (
            <label
              key={option.intervalCount}
              className={changeDeliveryDateModalClass.intervalLabel}
            >
              <input
                type="radio"
                name="interval"
                value={option.intervalCount}
                checked={selectedValue === option.intervalCount}
                onChange={(e) => {
                  setSelectedValue(Number(e.target.value));
                  postMessageGtag(eventName_selectPrefix + e.target.value, eventCategory);
                }}
              />
              {option.intervalCount}
              {option.unit}
            </label>
          ))}
        </div>
        <div
          className={commonModalClass.btnContainer}
          style={{ marginTop: '48px' }}
        >
          <button
            className={`${commonModalClass.btnPrimary} ${commonModalClass.grayOutDisabled}`}
            style={{ fontSize: '14px', height: '32px' }}
            onClick={() => {
              clickUpdateBtnFunc(selectedValue);
              postMessageGtag(eventName_changeIntervalBtn, eventCategory);
            }}
            disabled={loading || !isUpdateDate}
          >
            変更を完了する
          </button>
          <button
            className={commonModalClass.btnLink}
            style={{ fontSize: '14px' }}
            onClick={() => {
              closeFunc();
              postMessageGtag(eventName_closeBtn, eventCategory);
              window.parent.postMessage({ action: 'fixedBtnShow' }, '*');
            }}
          >
            閉じる
          </button>
        </div>
      </div>
    </>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={() => {
        closeFunc();
        postMessageGtag(eventName_closeOutsideBtn, eventCategory);
      }}
    >
      {content}
    </CommonModal>
  );
};

function getIntervals(
  intervalCount: number,
  interval: BillingPolicyIntervalType,
  billings: Billing[]
) {
  const MASTER_INTERVALS = [15, 30, 45, 4, 60];
  const displayIntervals: IntervalType[] = [];

  for (const num of MASTER_INTERVALS) {
    if (num !== 15 && num !== 4 && num !== intervalCount) continue;

    if (num === intervalCount) {
      displayIntervals.push({
        intervalCount: num,
        unit: INTERVAL_UNIT_MAP[interval] || '日ごと',
      });
      continue;
    }
    const found = billings.find((m) => m.billingPolicyIntervalCount === num);
    if (!found) continue;
    displayIntervals.push({
      intervalCount: num,
      unit: INTERVAL_UNIT_MAP[found?.billingPolicyInterval] || '日ごと',
    });
  }

  return displayIntervals;
}
